import { makeAutoObservable } from 'mobx';
import { getUserInfo } from '../api/xt-user';
// import {getRiskNotice} from '../api/xt-console';

export default class Console {
  isLogin = false;
  userInfo = {};
  riskNoticeList = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setIsLogin(login: boolean) {
    this.isLogin = login;
  }

  *fetchUserInfo(data) {
    const result = yield getUserInfo(data);

    this.userInfo = result;
    return result;
  }

  // *fetchRickNotice(data) {
  //   const result = yield getRiskNotice(data);
  //   this.riskNoticeList = result;
  //   return result;
  // }
}